<template>
  <div class="big">
    <div class="page_title">推荐入口</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div style="margin-bottom:20px">
          <span class="title">说明：</span>
          <span>推荐的商品都有时，优先级高的进行推荐；第一优先级没有时，推荐第二优先级商品，以此类推。</span>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table
            ref="multipleTable"
            :data="tableData"
            :span-method="objectSpanMethod"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="入口名"
              width="400"
              align="center"
              class-name="border-column"
            >
              <template slot-scope="scope">
                <div style="text-align:center">
                  <div
                    style="margin-bottom:10px"
                    v-if="scope.row.enter_id==1"
                  >用户端APP-购药订单完成页</div>
                  <div
                    style="margin-bottom:10px"
                    v-if="scope.row.enter_id==2"
                  >待接诊等待页</div>
                  <div
                    style="margin-bottom:10px"
                    v-if="scope.row.enter_id==3"
                  >预约等待页</div>
                  <div>
                    <el-button
                      type="primary"
                      plain
                      @click="checkDoctor(scope.row.enter_id)"
                      :disabled="
            module_id_array[0] ? !module_id_array.includes('901') : false
          "
                    >编辑/查看不推荐名单</el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="规则名"
              prop="recommend_name"
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="优先级"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="setSort(scope.row.rule_id,scope.row.enter_id,1)"
                  :disabled="
            module_id_array[0] ? !module_id_array.includes('900') : false
          "
                >置顶</el-button>
                <el-button
                  type="text"
                  @click="setSort(scope.row.rule_id,scope.row.enter_id,2)"
                  :disabled="
            module_id_array[0] ? !module_id_array.includes('900') : false
          "
                >上移</el-button>
                <el-button
                  type="text"
                  @click="setSort(scope.row.rule_id,scope.row.enter_id,3)"
                  :disabled="
            module_id_array[0] ? !module_id_array.includes('900') : false
          "
                >下移</el-button>
                <el-button
                  type="text"
                  @click="setSort(scope.row.rule_id,scope.row.enter_id,4)"
                  :disabled="
            module_id_array[0] ? !module_id_array.includes('900') : false
          "
                >置底</el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="开关"
              align="center"
            >
              <template slot-scope="scope">
                <el-switch
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('904')
                      : false
                  "
                  v-model="scope.row.status"
                  active-color="#669961"
                  inactive-color="#DC1F1F"
                  :active-value="1"
                  :inactive-value="0"
                  @change="value=>{return updateStatus(value,scope.row.rule_id)}"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      goods_keyword: '',
      keyword_name: '',
      tableData: [],
      chooseGoodShow: false,
      goods_list: [],
      keyword_id: '',
      department_list: [],
      good_at_dia: false,
      add_keyword_name: ''
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getList() {
      let data = {
        page: 1,
        pageNumber: 100
      };
      this.axios
        .post('platform/shop/recommendRuleList', data)
        .then((res) => {
          this.fomartList(res.data.list);
          this.totalNum = res.data.total;
        })
        .catch((err) => {});
    },
    //格式化列表
    fomartList(list) {
      let arr = [];
      list.forEach((ele) => {
        if (ele.item.length > 0) {
          ele.item.forEach((rule) => {
            let obj = {
              enter_id: ele.enter_id,
              recommend_name: rule.recommend_name,
              rule_id: rule.rule_id,
              sort: rule.sort,
              status: rule.status
            };
            arr.push(obj);
          });
        } else {
          ele.recommend_name = '';
          ele.rule_id = '';
          ele.sort = '';
          ele.status = '';
          arr.push(ele);
        }
      });
      this.tableData = arr;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let num = 0;
      if (columnIndex == 0) {
        this.tableData.forEach((ele) => {
          if (row.enter_id == ele.enter_id) {
            num++;
          }
        });
      }
      if (num == 1) {
        return {
          rowspan: 1,
          colspan: 1
        };
      } else if (num > 1) {
        if (
          this.tableData[rowIndex - 1] &&
          this.tableData[rowIndex].enter_id ==
            this.tableData[rowIndex - 1].enter_id
        ) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: num,
            colspan: 1
          };
        }
      }
    },
    //修改排序
    setSort(rule_id, enter_id, sort) {
      let data = {
        rule_id,
        enter_id,
        sort
      };
      this.axios
        .post('platform/shop/saveRecommendRuleSort', data)
        .then((res) => {
          this.$message.success('修改成功');
          this.getList();
        })
        .catch((err) => {
          this.getList();
        });
    },
    //选择医生
    checkDoctor(enter_id) {
      this.$router.push({
        path: 'recommenddoctor',
        query: {
          enter_id
        }
      });
    },
    // 修改规则状态
    updateStatus(value, rule_id) {
      let data = {
        status: value,
        rule_id
      };
      this.axios
        .post('platform/shop/updateRecommendRuleStatus', data)
        .then((res) => {
          this.$message.success('修改成功');
          this.getList();
        })
        .catch((err) => {
          this.getList();
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
  text-align: left;
}
.topbpx {
  display: flex;
  align-items: flex-end;
  margin: 20px 0;
}
.title {
  font-size: 18px;
  font-weight: 700;
}
.outstate {
  color: #ff7430;
  margin-left: 15px;
  border: 2px solid #ff7430;
  border-radius: 3px;
  padding: 2px 5px;
  font-weight: 700;
}
.border_right {
  border-right: 1px solid #333;
}
</style>
<style lang="scss">
.border-column {
  border-right: 1px solid #ebeef5;
}
</style>
